export default "/images/sidebar.svg?79c7aba125a90e93fa7ec267b8da7c01";